var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpdatesPaused(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23.9948,
    height: 23.9948,
    rx: 11.9974,
    fill: "#FF5959",
    fillOpacity: 0.33
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10162_77703)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9974 17.5514C15.0645 17.5514 17.5508 15.0652 17.5508 11.998C17.5508 8.93091 15.0645 6.44466 11.9974 6.44466C8.93026 6.44466 6.44401 8.93091 6.44401 11.998C6.44401 15.0652 8.93026 17.5514 11.9974 17.5514ZM18.6615 11.998C18.6615 15.6783 15.6776 18.6621 11.9974 18.6621C8.31716 18.6621 5.33333 15.6783 5.33333 11.998C5.33333 8.31782 8.31716 5.33398 11.9974 5.33398C15.6776 5.33398 18.6615 8.31782 18.6615 11.998Z",
    fill: "#E23131"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9974 14.7741C12.7338 14.7741 13.4401 14.4815 13.9608 13.9608C14.4815 13.4401 14.7741 12.7338 14.7741 11.9974C14.7741 11.261 14.4815 10.5547 13.9608 10.034C13.4401 9.51325 12.7338 9.2207 11.9974 9.2207C11.261 9.2207 10.5547 9.51325 10.034 10.034C9.51325 10.5547 9.2207 11.261 9.2207 11.9974C9.2207 12.7338 9.51325 13.4401 10.034 13.9608C10.5547 14.4815 11.261 14.7741 11.9974 14.7741Z",
    fill: "#E23131"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10162_77703"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.3281,
    height: 13.3281,
    fill: "white",
    transform: "translate(5.33333 5.33398)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdatesPaused);
export default __webpack_public_path__ + "static/media/updates-paused.5d9ab5cd726ee88980a1e72dfa04c9e2.svg";
export { ForwardRef as ReactComponent };